(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eos-holiday-catalog"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('eos-catalog-wishlist')) {
  customElements.define('eos-catalog-wishlist', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const opts = {signal: this.controller.signal};
      this.init = () => {
        if (!this.isConnected || this.initialized) return;
        this.button = this.querySelector('[data-toggle]');
        this.grid = this.querySelector('.eosc-tiles');
        if (!this.button || !this.grid) return;
        this.initialized = true;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.connection = navigator.connection;
        this.manual = this.motion.matches || Boolean(this.connection?.saveData);
        this.userPaused = false;
        this.visible = false;
        this.started = false;
        this.timer = null;
        this.remaining = 3600;
        this.setAttribute('data-running', '');
        this.removeAttribute('data-photos');
        this.dataset.animationVersion = '20261103-cover-first';
        this.button.hidden = false;
        this.sync = () => {
          this.button.textContent = this.manual
            ? (this.hasAttribute('data-running') && !this.hasAttribute('data-photos') ? this.dataset.showBracelets : this.dataset.showCards)
            : (this.userPaused ? this.dataset.play : this.dataset.pause);
        };
        this.suspend = () => {
          if (this.timer !== null) {
            this.remaining = Math.max(0, this.dueAt - performance.now());
            clearTimeout(this.timer);
            this.timer = null;
          }
        };
        this.schedule = () => {
          if (this.timer !== null || !this.isConnected || !this.visible || document.hidden || this.manual || this.userPaused) return;
          if (!this.started) {
            this.started = true;
            this.setAttribute('data-running', '');
            this.removeAttribute('data-photos');
            this.remaining = 3600;
          }
          this.dueAt = performance.now() + this.remaining;
          this.timer = setTimeout(() => {
            this.timer = null;
            if (!this.isConnected || !this.visible || document.hidden || this.manual || this.userPaused) return;
            this.toggleAttribute('data-photos');
            this.remaining = this.hasAttribute('data-photos') ? 2700 : 3600;
            this.schedule();
          }, this.remaining);
        };
        this.button.addEventListener('click', () => {
          this.suspend();
          if (this.manual) {
            const showCards = !this.hasAttribute('data-running') || this.hasAttribute('data-photos');
            this.setAttribute('data-running', '');
            this.toggleAttribute('data-photos', !showCards);
          } else {
            this.userPaused = !this.userPaused;
            if (!this.userPaused) {
              this.started = false;
              this.schedule();
            }
          }
          this.sync();
        }, opts);
        const preferencesChanged = () => {
          const manual = this.motion.matches || Boolean(this.connection?.saveData);
          if (manual === this.manual) return;
          this.suspend();
          this.manual = manual;
          this.started = false;
          this.setAttribute('data-running', '');
          this.removeAttribute('data-photos');
          this.sync();
          this.schedule();
        };
        this.motion.addEventListener('change', preferencesChanged, opts);
        this.connection?.addEventListener('change', preferencesChanged, opts);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.suspend();
          else this.schedule();
        }, opts);
        window.addEventListener('pagehide', () => this.suspend(), opts);
        window.addEventListener('pageshow', () => this.schedule(), opts);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            const entry = entries[entries.length - 1];
            const visible = entry.isIntersecting && entry.intersectionRatio >= 0.2;
            if (visible === this.visible) return;
            this.visible = visible;
            if (visible) this.schedule();
            else this.suspend();
          }, {threshold: [0, 0.2]});
          this.observer.observe(this.grid);
        } else {
          this.visible = true;
          this.schedule();
        }
        this.sync();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.init, {...opts, once: true});
      else this.init();
    }
    disconnectedCallback() {
      this.suspend?.();
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eos-holiday-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('eos-holiday-motion')) {
  customElements.define('eos-holiday-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.manualPause = this.reducedMotion.matches || Boolean(navigator.connection?.saveData);
      this.inView = true;
      this.video.muted = true;
      this.button.hidden = false;
      this.syncButton = () => {
        this.button.textContent = this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
      };
      this.video.addEventListener('loadeddata', () => this.setAttribute('data-ready', ''), options);
      this.video.addEventListener('play', this.syncButton, options);
      this.video.addEventListener('pause', this.syncButton, options);
      this.video.addEventListener('error', () => {
        this.removeAttribute('data-ready');
        this.button.hidden = true;
      }, options);
      this.button.addEventListener('click', () => {
        if (this.video.paused) {
          this.manualPause = false;
          this.startVideo();
        } else {
          this.manualPause = true;
          this.video.pause();
        }
      }, options);
      this.reducedMotion.addEventListener('change', (event) => {
        if (event.matches) {
          this.manualPause = true;
          this.video.pause();
        }
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
        else if (this.inView && !this.manualPause) this.startVideo();
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          this.inView = entries[0].isIntersecting;
          if (!this.inView) this.video.pause();
          else if (!this.manualPause && !document.hidden) this.startVideo();
        }, { threshold: 0.05 });
        this.observer.observe(this);
      } else if (!this.manualPause && !document.hidden) {
        this.startVideo();
      }
      this.syncButton();
    }
    startVideo() {
      if (!this.video.getAttribute('src')) this.video.src = this.video.dataset.src;
      this.video.muted = true;
      const attempt = this.video.play();
      if (attempt?.catch) attempt.catch(() => this.syncButton());
    }
    disconnectedCallback() {
      this.video?.pause();
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eos-holiday-finish"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('eos-garland-glow')) {
  customElements.define('eos-garland-glow', class extends HTMLElement {
    connectedCallback() {
      if (this.controller || this.dataset.enabled === 'false') return;
      this.controller = new AbortController();
      const opts = {signal:this.controller.signal};
      this.init = () => {
        if (!this.isConnected || this.root) return;
        this.root = (this.closest('main') || document).querySelector('.eosc');
        if (!this.root) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = false;
        try { this.paused = sessionStorage.getItem('eos-garland-paused') === 'true'; } catch (_) {}
        this.layer = document.createElement('div');
        this.layer.className = 'eos-glow-layer';
        this.layer.id = `${this.root.id || 'eos-catalog'}-garland`;
        this.layer.setAttribute('aria-hidden','true');
        this.root.classList.add('eos-glow-ready');
        this.root.append(this.layer);
        this.button = document.createElement('button');
        this.button.type = 'button';
        this.button.className = 'eos-glow-toggle';
        this.button.setAttribute('aria-controls',this.layer.id);
        const controls = this.root.querySelector('.eosc-wishlist__foot') || this.root.querySelector('.eosc-close');
        if (!controls) { this.layer.remove(); this.root.classList.remove('eos-glow-ready'); return; }
        controls.append(this.button);
        this.sync = () => {
          this.layer.toggleAttribute('data-paused',this.paused || this.motion.matches || document.hidden);
          this.button.textContent = this.paused ? this.dataset.play : this.dataset.pause;
          this.button.hidden = this.motion.matches;
        };
        this.button.addEventListener('click',() => {
          this.paused = !this.paused;
          try { sessionStorage.setItem('eos-garland-paused',String(this.paused)); } catch (_) {}
          this.sync();
        },opts);
        this.motion.addEventListener('change',this.sync,opts);
        document.addEventListener('visibilitychange',this.sync,opts);
        if ('IntersectionObserver' in window) {
          this.visibility = new IntersectionObserver(entries => {
            entries.forEach(entry => entry.target.toggleAttribute('data-visible',entry.isIntersecting));
          },{rootMargin:'100px'});
        }
        this.draw = () => {
          if (!this.root?.isConnected) return;
          const width = this.root.clientWidth;
          const height = this.root.scrollHeight;
          const signature = `${width}:${height}`;
          if (this.dimensions === signature) return;
          this.dimensions = signature;
          const cycle = width <= 749 ? 720 : Math.min(1200,Math.max(720,window.innerWidth * .5625));
          const wrap = this.root.querySelector('.eosc-wrap');
          const gutter = Math.max(12,(width - (wrap?.getBoundingClientRect().width || width - 36))/2);
          const offset = Math.max(7,Math.min(width * .038,gutter * .62));
          const fragment = document.createDocumentFragment();
          this.visibility?.disconnect();
          let count = 0;
          const pattern = [[0,.14,.85],[1,.26,1],[0,.64,1],[1,.82,.72]];
          for (let y = 0; y < height && count < 96; y += cycle) {
            for (const [right,phase,spread] of pattern) {
              const top = y + cycle * phase;
              if (top > height - 16 || count >= 96) continue;
              const light = document.createElement('span');
              light.className = 'eos-glow-light';
              light.style.left = `${right ? width - offset * spread : offset * spread}px`;
              light.style.top = `${top}px`;
              light.style.setProperty('--glow-duration',`${11 + (count % 4) * 2}s`);
              light.style.setProperty('--glow-delay',`${-(count * 2.73 % 17)}s`);
              if (!this.visibility) light.setAttribute('data-visible','');
              fragment.append(light);
              count++;
            }
          }
          this.layer.replaceChildren(fragment);
          this.layer.querySelectorAll('.eos-glow-light').forEach(light => this.visibility?.observe(light));
        };
        const schedule = () => {
          cancelAnimationFrame(this.drawFrame);
          this.drawFrame = requestAnimationFrame(this.draw);
        };
        if ('ResizeObserver' in window) {
          this.resize = new ResizeObserver(schedule);
          this.resize.observe(this.root);
        }
        window.addEventListener('resize',schedule,opts);
        this.draw();
        this.sync();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',this.init,{...opts,once:true});
      else this.initFrame = requestAnimationFrame(this.init);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.drawFrame);
      this.controller?.abort();
      this.resize?.disconnect();
      this.visibility?.disconnect();
      this.layer?.remove();
      this.button?.remove();
      this.root?.classList.remove('eos-glow-ready');
      this.controller = null;
      this.root = null;
      this.dimensions = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eos-holiday-stories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('eos-holiday-story-count')) {
  customElements.define('eos-holiday-story-count', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.number = this.querySelector('[data-number]');
      this.time = this.querySelector('[data-time]');
      if (!this.number || !this.time) return;
      this.events = new AbortController();
      document.addEventListener('visibilitychange', () => {
        clearTimeout(this.timer);
        if (document.hidden) this.request?.abort();
        else this.refresh();
      }, {signal:this.events.signal});
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.isConnected && !document.hidden) this.timer = setTimeout(() => this.refresh(), 60000);
    }
    async refresh() {
      if (!this.isConnected || document.hidden || this.busy) return;
      this.busy = true;
      const controller = this.request = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const url = new URL(location.href);
        url.hash = '';
        url.searchParams.delete('sections');
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url.pathname + url.search, {credentials:'same-origin',cache:'no-store',signal:controller.signal,headers:{Accept:'text/html'}});
        if (!response.ok) throw new Error('Unavailable');
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const next = doc.querySelector('eos-holiday-story-count');
        if (!next || !/^\d+$/.test(next.dataset.count || '')) throw new Error('Invalid snapshot');
        const count = Number(next.dataset.count);
        const checked = Date.parse(next.dataset.asOf);
        const previous = Date.parse(this.dataset.asOf);
        if (!Number.isSafeInteger(count) || count <= 0 || count > 100000000 || !Number.isFinite(checked) || checked < previous || !this.isConnected) return;
        const number = next.querySelector('[data-number]');
        const time = next.querySelector('[data-time]');
        if (!number || !time) return;
        if (this.number.textContent !== number.textContent) this.number.textContent = number.textContent;
        this.number.setAttribute('aria-label', number.getAttribute('aria-label') || number.textContent);
        this.dataset.count = String(count);
        this.dataset.asOf = next.dataset.asOf;
        this.time.dateTime = next.dataset.asOf;
        this.time.textContent = time.textContent;
      } catch (_) {
      } finally {
        clearTimeout(timeout);
        this.busy = false;
        this.schedule();
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.request?.abort();
      this.events?.abort();
      this.events = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
